/**
 * @generated SignedSource<<6ac6be19026c96b0b0d35e3a29d97158>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LabelEmbedQuery$variables = {
  tql: string;
  uuid: string;
  workspaceUuid: string;
};
export type LabelEmbedQuery$data = {
  readonly tagByUuid: {
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"LabelEmbedContent" | "LabelEmbedHeader">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectTimeline">;
};
export type LabelEmbedQuery = {
  response: LabelEmbedQuery$data;
  variables: LabelEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = [
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "tql"
  },
  {
    "kind": "Variable",
    "name": "workspaceUuid",
    "variableName": "workspaceUuid"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v11 = {
  "kind": "ScalarField",
  "name": "private"
},
v12 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v13 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aaid"
    },
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        {
          "kind": "ScalarField",
          "name": "accountId"
        }
      ]
    },
    (v7/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "label"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v16 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = [
  (v17/*: any*/),
  (v14/*: any*/),
  (v16/*: any*/)
],
v19 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v20 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confidence"
    },
    (v14/*: any*/),
    (v16/*: any*/),
    {
      "alias": "tooltip",
      "args": (v19/*: any*/),
      "kind": "ScalarField",
      "name": "label",
      "storageKey": "label(longFormat:true)"
    },
    {
      "alias": "localizedTooltip",
      "args": (v19/*: any*/),
      "concreteType": "LocalizationField",
      "kind": "LinkedField",
      "name": "localizedLabel",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": "localizedLabel(longFormat:true)"
    },
    {
      "kind": "ScalarField",
      "name": "overdue"
    }
  ]
},
v21 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v22 = {
  "kind": "ScalarField",
  "name": "score"
},
v23 = {
  "kind": "ScalarField",
  "name": "creationDate"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "LabelEmbedQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "tagByUuid",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "LabelEmbedContent"
            },
            {
              "kind": "FragmentSpread",
              "name": "LabelEmbedHeader"
            }
          ]
        },
        "action": "THROW",
        "path": "tagByUuid"
      },
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectTimeline"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LabelEmbedQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "ProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "CompletionProjectState",
                            "kind": "LinkedField",
                            "name": "atCompletionState",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          }
                        ]
                      },
                      (v20/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "concreteType": "Workspace",
                        "kind": "LinkedField",
                        "name": "workspace",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "GoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v4/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "CompletionGoalState",
                            "kind": "LinkedField",
                            "name": "atCompletionState",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v22/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasSubgoalMatches"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          }
                        ],
                        "concreteType": "GoalUpdateConnection",
                        "kind": "LinkedField",
                        "name": "updates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "summary"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "missedUpdate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "updateType"
                                  },
                                  (v23/*: any*/),
                                  {
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "canPostUpdate"
                                      },
                                      (v7/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "updates(first:1)"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v9/*: any*/),
          (v7/*: any*/)
        ]
      },
      {
        "alias": "projectTimeline",
        "args": (v5/*: any*/),
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          },
          {
            "concreteType": "ProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  (v23/*: any*/),
                  {
                    "concreteType": "ProjectState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": (v18/*: any*/)
                  },
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "targetDateConfidence"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetDateSet"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "ProjectPhaseDetails",
                    "kind": "LinkedField",
                    "name": "newPhase",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "alias": "projectTimeline",
        "args": (v5/*: any*/),
        "filters": [
          "workspaceUuid",
          "q",
          "directoryViewUuid",
          "sort"
        ],
        "handle": "connection",
        "key": "ProjectTimeline__projectTimeline",
        "kind": "LinkedHandle",
        "name": "projectTql"
      }
    ]
  },
  "params": {
    "cacheID": "2662fcdbf143add00251069885385ab4",
    "id": null,
    "metadata": {},
    "name": "LabelEmbedQuery",
    "operationKind": "query",
    "text": "query LabelEmbedQuery(\n  $uuid: UUID!\n  $workspaceUuid: UUID!\n  $tql: String!\n) {\n  tagByUuid(uuid: $uuid) {\n    name\n    ...LabelEmbedContent\n    ...LabelEmbedHeader\n    id\n  }\n  ...ProjectTimeline_1fDVnR\n}\n\nfragment ExpandableProjectsList_data on Tag {\n  name\n  projects {\n    edges {\n      node {\n        id\n        key\n        uuid\n        targetDate\n        ...ProjectEmbedRow\n      }\n    }\n  }\n}\n\nfragment GoalEmbedRow_1TeGsN on Goal {\n  ...GoalName\n  id\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  hasSubgoalMatches\n}\n\nfragment GoalEmbedUpdate on GoalUpdate {\n  uuid\n  summary\n  missedUpdate\n  updateType\n  creationDate\n  goal {\n    key\n    uuid\n    canPostUpdate\n    id\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment LabelEmbedContent on Tag {\n  __typename\n  name\n  ...ExpandableProjectsList_data\n  ...LabelExpandableGoalsList_data\n}\n\nfragment LabelEmbedHeader on Tag {\n  uuid\n  name\n}\n\nfragment LabelExpandableGoalsList_data on Tag {\n  name\n  goals {\n    edges {\n      node {\n        id\n        key\n        uuid\n        targetDate\n        workspace {\n          uuid\n          id\n        }\n        ...GoalEmbedRow_1TeGsN\n        updates(first: 1) {\n          edges {\n            node {\n              ...GoalEmbedUpdate\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectBar on Project {\n  startDate\n  creationDate\n  state {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n  targetDate\n  targetDateConfidence\n  targetDateSet\n  ...ProjectName_data\n  ...utilsGetProjectTargetEndDate\n}\n\nfragment ProjectEmbedRow on Project {\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...ProjectState\n  }\n  dueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTimeline_1fDVnR on Query {\n  projectTimeline: projectTql(workspaceUuid: $workspaceUuid, q: $tql) {\n    count\n    edges {\n      node {\n        uuid\n        startDate\n        creationDate\n        ...ProjectBar\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment utilsGetProjectTargetEndDate on Project {\n  newPhase {\n    name\n  }\n  startDate\n  creationDate\n  targetDate\n  targetDateConfidence\n  targetDateSet\n}\n"
  }
};
})();

(node as any).hash = "931e7881848782cb0d923bc3f4eeef1c";

export default node;
